/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jolly_Formal_Quail_GaspInputs */

const fr_jolly_formal_quail_gasp = /** @type {(inputs: Jolly_Formal_Quail_GaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la catégorie`)
};

/**

* @param {Jolly_Formal_Quail_GaspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jolly_formal_quail_gasp = /** @type {((inputs?: Jolly_Formal_Quail_GaspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jolly_Formal_Quail_GaspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jolly_formal_quail_gasp(inputs)
});